/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTableauView = /* GraphQL */ `
  query GetTableauView($id: ID!) {
    getTableauView(id: $id) {
      id
      name
      link
      createdBy
      userEmail
      isDefault
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTableauViews = /* GraphQL */ `
  query ListTableauViews(
    $filter: ModelTableauViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTableauViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdBy
        userEmail
        quicksightDashboardId
        isDefault
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const viewsByEmail = /* GraphQL */ `
  query ViewsByEmail(
    $userEmail: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTableauViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    viewsByEmail(
      userEmail: $userEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        link
        createdBy
        userEmail
        isDefault
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
